"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var pluralizer = function pluralizeWords(count, word) {
  if (count === 1) {
    return word;
  }

  return "".concat(word, "s");
};

var _default = pluralizer;
exports["default"] = _default;